<template>
    <ui-modal-info
        :name="name"
        :loading="loader.overlayLoading"
        :success="loader.overlaySucess"
        :body-loading="loader.body"
        :can-submit="canSubmit"
        :cancel-track-event="gtm.cancel"
        :action="submit"
        title="Tem certeza que deseja excluir este negócio?"
        icon="fal fa-trash-alt"
        color-circle="#FF557C"
        btn-text="Excluir"
        btn-type="danger"
        icon-circle
        footer
    >
        <template #top-modal>
            <ui-tag-indicator :color="modal.idle_color" :text="`${modal.id}`" text-size="10" />
        </template>

        <div class="header-obs">
            Digite o código <span>{{ modal.id }}</span> para confirmar a exclusão.
        </div>

        <div class="confirmation">
            <ui-confirm-code v-model="form.code" :correct="canSubmit" :size="confirmCodeSize" />
        </div>

        <div class="footer-obs">Após a confirmação não será possível desfazer esta ação.</div>
    </ui-modal-info>
</template>

<script>
	import { uiTagIndicator } from '@/components/ui/tags'
	import { uiModalInfo } from '@/components/ui/modal'
	import { uiConfirmCode } from '@/components/ui'

	import { utilMixin, alertMixin, modalMixin } from '@/mixins'

	import { deal } from '@/services/axios'
	import { defaultGtm } from './default'

	const defaultModal = () => ({
		id: '',
		idle_color: '',
		column: null,
	})

	const defaultForm = () => ({
		code: '',
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: false,
		overlaySucess: false,
	})

	export default {
		name: 'ui-delete-deal-modal',

		components: {
			uiModalInfo,
			uiTagIndicator,
			uiConfirmCode,
		},

		mixins: [utilMixin, alertMixin, modalMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
			sucessEvent: {
				type: String,
				required: true,
			}
		},

		data() {
			return {
				modal: { ...defaultModal() },
				loader: { ...defaultLoader() },
				form: { ...defaultForm() },
				gtm: { ...defaultGtm() },
			}
		},

		computed: {
			obsMessage() {
				return `Digite o código ${this.modal.id} para confirmar a exclusão.`
			},

			canSubmit() {
				return this.modal.id == this.form.code
			},

			confirmCodeSize() {
				return `${this.modal.id}`.length
			},
		},

		mounted() {
			this.$root.$on('modal-open-' + this.name, async (payload) => {
				this.reset()
				this.$root.$emit('clear-confirm-code')

				if (payload.id) this.modal.id = payload.id
				if (payload.idle_color) this.modal.idle_color = payload.idle_color

				this.modal.column = payload.stage_position
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-' + this.name)
		},

		methods: {
			reset() {
				this.modal = { ...defaultModal() }
				this.loader = { ...defaultLoader() }
				this.form = { ...defaultForm() }
			},

			async submit() {
				if (!this.canSubmit) return

				try {
					this.loader.overlayLoading = true

					const response = await deal.delete('', this.modal.id)
					if (response.data?.status !== 'success') throw new Error(response.data.msg)

					this.$root.$emit(this.sucessEvent, {
						column: this.modal.column,
						id: this.modal.id
					})
					this.$gtm.trackEvent(this.gtm.submit)

					setTimeout(() => {
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.$mx_closeModal()
						}, 500)
					}, 500)

				} catch (error) {
					if (error.data?.msg) {
						this.$mx_alertError(error.data.msg)

					} else {
						this.$mx_alertError(error)
					}
					console.log(error)

					setTimeout(() => {
						this.loader.overlayLoading = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
